export interface VideoUrlModel {
  url?: string;
  url360?: string;
  date?: Date;
}

export interface VideoModel {
  name: string;
  pro?: VideoUrlModel
  liv?: VideoUrlModel
  qui?: VideoUrlModel
  thumbUrl: string;
  date?: Date;
}

export const isLive = (videoUrl: VideoUrlModel): boolean => {
  return (videoUrl.url !== undefined || videoUrl.url360 !== undefined) && (!videoUrl.date || videoUrl.date < new Date());
}
